// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__lXQQK","label":"Section_label__1fzpx","contentWrap":"Section_contentWrap__nv-Lh","footer":"Section_footer__3umMn","footerInner":"Section_footerInner__iqQPa"};